/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import { DataContainer, DataItem } from "~/components";
import { useCurrency } from "~/hooks";
import { formatMoney, isNotNil } from "~/tools";

type Props = {
  totalCost?: string;
  count?: number | null;
  monthlySavings?: string | null;
  isLoading?: boolean;
};

export function CostData({
  totalCost,
  count,
  monthlySavings,
  isLoading = false,
}: Props) {
  const { currency } = useCurrency();

  return (
    <DataContainer width="100%">
      <DataItem
        label="Total Cost"
        value={formatMoney(totalCost, currency)}
        grow={false}
        loading={isLoading}
        valueFontWeight={theme.fontWeights.medium}
        itemWidth="12.5%"
      />
      <DataItem
        label="Monthly Forecast"
        value="-"
        grow={false}
        loading={isLoading}
        valueFontWeight={theme.fontWeights.medium}
        itemWidth="12.5%"
      />
      <DataItem
        label="Potential Monthly Savings"
        grow={false}
        valueFontWeight={theme.fontWeights.medium}
        loading={isLoading}
        itemWidth="12.5%"
        value={
          isNotNil(monthlySavings) ? formatMoney(monthlySavings, currency) : "-"
        }
      />
      <DataItem
        label="Next 12 Months Savings"
        grow={false}
        valueFontWeight={theme.fontWeights.medium}
        loading={isLoading}
        itemWidth="12.5%"
        value={
          isNotNil(monthlySavings)
            ? formatMoney(Number(monthlySavings) * 12, currency)
            : "-"
        }
      />
      <DataItem
        label="Total Estate Records"
        value={isNotNil(count) ? count?.toString() : "-"}
        grow={false}
        valueFontWeight={theme.fontWeights.medium}
        loading={isLoading}
        itemWidth="12.5%"
      />
    </DataContainer>
  );
}
